import type { OrderCancelSuccess } from '~/services/api/generated'
import type { ApiResponse } from '~/services/api/interfaces'
import type { OrderDetail } from '~/types/order/OrderDetail'
import { normalizeOrderDetail } from './normalizeOrderDetail'

export const normalizeCancelOrderResponse = (
  response: OrderCancelSuccess
): ApiResponse<{ order: OrderDetail }> => {
  return {
    data: { order: normalizeOrderDetail(response.data.order) },
    message: response.message,
    status: response.success
  }
}
